<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #f6d365 0%, #fda085 100%);">
            <i class="fa fa-truck text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Ordem de Expedição</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Gestão de embarques e ordens</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
                    <cec-input-data ref="edDT1" v-model="dt1" class="mx-1"  style="width: 145px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="edDT2" v-model="dt2" class="mx-1" style="width: 145px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="btn-filtrar-responsive px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button ref="btAdicionar" variant="success" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span class="d-none d-sm-inline">Nova Ordem</span>
              <span class="d-sm-none">Novo</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Nº Pedido</label>
                      <b-form-input type="text" v-model="pedido" placeholder="Ex: 12345" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="2">
                      <label class="font-weight-bold text-muted small">Cod. Controle</label>
                      <b-form-input type="text" v-model="id" placeholder="Ex: 987" class="custom-input-premium" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                    <b-col md="8">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Cliente"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col md="12">
                      <label class="font-weight-bold text-muted small d-block mb-2">Situações</label>
                      <b-form-select :plain="true" class="custom-input-premium" v-model="tipoSituacao" :options="optionsSituacao">
                      </b-form-select>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>
    
      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="p-0">
            <!-- Main table element -->
            
            <b-table class="modern-premium-table"
                    show-empty
                    empty-text="Informe o filtro para ver as ordens de expedição"
                    stacked="sm"
                    small
                    responsive 
                    caption-top
                    :sticky-header="stickyHeight"
                    :head-variant="isDark ? 'dark' : 'light'"
                    hover 
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="fields"
                    :current-page="currentPage"
                    :per-page="perPage"
                    select-mode="single"
                    selectable
                    @row-clicked="selecionarLinha"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"
                    ref="tabelaPrincipal"
                    
                    >
              <template #head(ID)>
                <SetFilter
                  label="ID"
                  v-model="filtros.ID"
                  :options="opcoes.ID"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(STATUS)>
                <SetFilter
                  label="Status"
                  v-model="filtros.STATUS"
                  :options="opcoes.STATUS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(PLACA)>
                <SetFilter
                  label="Placa"
                  v-model="filtros.PLACA"
                  :options="opcoes.PLACA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(NOME_MOTORISTA)>
                <SetFilter
                  label="Motorista"
                  v-model="filtros.NOME_MOTORISTA"
                  :options="opcoes.NOME_MOTORISTA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(NOME_RESPONSAVEL)>
                <SetFilter
                  label="Responsável"
                  v-model="filtros.NOME_RESPONSAVEL"
                  :options="opcoes.NOME_RESPONSAVEL"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(PEDIDOS)>
                <SetFilter
                  label="Pedido"
                  v-model="filtros.PEDIDOS"
                  :options="opcoes.PEDIDOS"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(UNIDADES)>
                <SetFilter
                  label="Unidades"
                  v-model="filtros.UNIDADES"
                  :options="opcoes.UNIDADES"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(QUANT)>
                <SetFilter
                  label="Peso"
                  v-model="filtros.QUANT"
                  :options="opcoes.QUANT"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(DATA)>
                <SetFilter
                  label="Data"
                  v-model="filtros.DATA"
                  :options="opcoes.DATA"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>
              <template #head(USUARIO_CADASTRO)>
                <SetFilter
                  label="Cadastro"
                  v-model="filtros.USUARIO_CADASTRO"
                  :options="opcoes.USUARIO_CADASTRO"
                  :normalizeFn="normalize"
                  :dropdown-variant="isDark ? 'dark' : 'none'"
                />
              </template>

              <template #cell(STATUS)="item">
                <b-badge pill :variant="colorirStatus(item.item.STATUS)">{{traduzirSituacao(item.item.STATUS)}}</b-badge>
              </template>      
              <template #cell(PEDIDOS)="item">
                <div class="d-flex flex-column align-items-end">
                  <span class="font-weight-bold">{{ item.item.PEDIDOS }}</span>
                  <b-badge v-if="item.item.PEDIDOS_COM_LOTE > 0" 
                           pill 
                           :variant="item.item.PEDIDOS_COM_LOTE >= item.item.PEDIDOS ? 'success' : 'warning'"
                           class="mt-1"
                           style="font-size: 0.65rem; min-width: 45px;">
                    <i class="fa fa-cubes mr-1"></i>{{ item.item.PEDIDOS_COM_LOTE }}/{{ item.item.PEDIDOS }}
                  </b-badge>
                  <b-badge v-else pill variant="light" class="mt-1 border text-muted" style="font-size: 0.65rem;">
                    Sem Lotes
                  </b-badge>
                  <b-badge v-if="item.item.PEDIDOS_ENTREGUES > 0 && item.item.PEDIDOS_ENTREGUES >= item.item.PEDIDOS"
                           pill variant="success" class="mt-1" style="font-size: 0.65rem;">
                    <i class="fa fa-check mr-1"></i>Entregues
                  </b-badge>
                  <b-badge v-else-if="item.item.PEDIDOS_ENTREGUES > 0"
                           pill variant="info" class="mt-1" style="font-size: 0.65rem;">
                    <i class="fa fa-truck mr-1"></i>{{ item.item.PEDIDOS_ENTREGUES }}/{{ item.item.PEDIDOS }}
                  </b-badge>
                </div>
              </template>
              <template #cell(actions)="{ detailsShowing, item }">
                <b-button-group size="sm">
                  <b-button
                    v-if="item.PEDIDOS > 0 && item.PEDIDOS_ENTREGUES >= item.PEDIDOS && item.STATUS !== '5'"
                    size="sm"
                    variant="success"
                    title="Confirmar Entrega Total"
                    v-b-tooltip.hover.left
                    @click.stop="confirmarEntregaEmbarque(item)"
                  >
                    <i class="fa fa-flag-checkered"></i>
                  </b-button>
                  <b-button v-if="item.STATUS === '1'"  type="button" @click="abrirModalCancelamento(item)" size="sm" variant="danger" title="Cancelar Embarque" v-b-tooltip.hover.left>
                    <i class="fa fa-close"></i>
                  </b-button>
                  <b-button type="button" variant="info" title="Detalhes" size="sm" v-b-tooltip.hover.left
                          @click="exibirDetalhesTabela(item)">
                    <i v-if="detailsShowing" class="fa fa-arrow-up"></i>
                    <i v-else class="fa fa-arrow-down"></i>
                  </b-button>
                  <b-dropdown id="btImprimir" :disabled="true" no-caret size="sm" variant="warning" :menu-class="isDark ? 'bg-dark' : 'bg-gray-600'">
                    <template #button-content>
                      <i class="fa fa-print"></i>    
                    </template>
                    <b-dropdown-item @click.stop.prevent="imprimir(item.ID)" >Manifesto de Embarque</b-dropdown-item>
                    <b-dropdown-item @click.stop.prevent="imprimir(item.ID)">Resumo do Embarque</b-dropdown-item>
                    <b-dropdown-item @click.stop.prevent="imprimir(item.ID)">Conferência - Auditoria</b-dropdown-item>
                  </b-dropdown>
                </b-button-group>
              </template>
              <template #row-details="row">
                <b-card  class="p-0">
                  <div slot="header">
                    <strong class="text-center">Pedidos nesse Embarque</strong>
                  </div>
                  <b-table class="table table-sm p-0"
                        show-empty
                        empty-text="Nenhum Pedido nessa Ordem "
                        stacked="sm"
                        small
                        responsive 
                        caption-top
                        sticky-header
                        :head-variant="isDark ? 'dark' : 'light'"
                        hover 
                        :busy.sync="tabelaPedidosEmbarcados.isBusy" 
                        :items="tabelaPedidosEmbarcados.items" 
                        :fields="tabelaPedidosEmbarcados.fields"
                        :current-page="tabelaPedidosEmbarcados.currentPage"
                        :per-page="tabelaPedidosEmbarcados.perPage"
                        :tbody-tr-class="rowClassPedidoEntregue"
                        select-mode="single"
                        >
                  
                      <template #cell(OP_PEDIDO)="tipo">
                        <b-badge pill :variant="colorirTipoPedido(tipo.item.OP_PEDIDO)">{{traduzirTipoPedido(tipo.item.OP_PEDIDO)}}</b-badge>
                      </template>    
                      <template #cell(ABATE_ID)="item">
                        <b-badge v-if="item.item.QUANT_VINCULADA >= item.item.QUANT_TOTAL_ITENS && item.item.QUANT_TOTAL_ITENS > 0" pill variant="success" class="shadow-xs">
                          <i class="fa fa-check mr-1"></i> Completo
                        </b-badge>
                        <b-badge v-else-if="item.item.QUANT_VINCULADA > 0" pill variant="warning" class="shadow-xs">
                          <i class="fa fa-exclamation-triangle mr-1"></i> Parcial
                        </b-badge>
                        <b-badge v-else pill variant="light" class="border text-muted">
                          <i class="fa fa-clock-o mr-1"></i> Pendente
                        </b-badge>
                      </template>
                      <template #cell(OP_RETORNO_ENTREGA)="pedido">
                        <b-badge v-if="pedido.item.OP_RETORNO_ENTREGA === '1'" pill variant="success">
                          <i class="fa fa-check mr-1"></i>Entregue
                        </b-badge>
                        <b-badge v-else pill variant="secondary">Pendente</b-badge>
                      </template>
                      <template #cell(actions)="pedido">
                        <b-button-group size="sm">
                          <b-button
                            size="sm"
                            variant="success"
                            title="Confirmar Entrega"
                            v-b-tooltip.hover.left
                            :disabled="pedido.item.OP_RETORNO_ENTREGA === '1'"
                            @click.stop="confirmarEntregaPedidoEmbarque(pedido.item, row.ID)"
                          >
                            <i class="fa fa-truck"></i>
                          </b-button>
                          <b-button
                            size="sm"
                            variant="info"
                            title="Ver Ocorrências"
                            v-b-tooltip.hover.left
                            @click.stop="abrirOcorrenciasEmbarque(pedido.item)"
                          >
                            <i class="fa fa-file-text-o"></i>
                          </b-button>
                          <b-button
                            size="sm"
                            variant="secondary"
                            title="Ver Canhotos/Docs"
                            v-b-tooltip.hover.left
                            @click.stop="abrirDocumentosEmbarque(pedido.item)"
                          >
                            <i class="fa fa-paperclip"></i>
                          </b-button>
                        </b-button-group>
                      </template>
                    
                  </b-table>

                </b-card>  
              </template>

              <template v-slot:custom-foot>
                <!-- You can customize this however you want, this is just as an example 
                https://stackoverflow.com/questions/59983216/double-footer-on-vue-boostrap-table-component
                -->
                <b-tr>
                  <!-- Total de linhas -->
                  <b-td class="text-left" colspan="1">{{ itensFiltrados.length }} - Ordens</b-td>
                  <!-- Espaço extra para compensar a coluna STATUS -->
                  <b-td></b-td>
                  <!-- Espaço extra para compensar a coluna PLACA -->
                  <b-td></b-td>
                  <!-- Espaço extra para compensar a coluna NOME_MOTORISTA -->
                  <b-td></b-td>
                  <!-- Espaço extra para compensar a coluna NOME_RESPONSAVEL -->
                  <b-td></b-td>
                  <!-- Espaço extra para compensar a coluna PEDIDOS -->
                  <b-td class="text-right" colspan="1">{{ somarQuantidadePedidos() }}</b-td>
                  <!-- Espaço extra para compensar a coluna UNIDADES -->
                  <b-td></b-td>
                  <!-- Total da quantidade -->
                  <b-td class="text-right" colspan="1">{{ somarTotalPeso() }}</b-td>
                  <!-- Espaço extra para compensar as colunas restantes -->
                  <b-td class="text-right" colspan="3"></b-td>
                </b-tr>
              </template>
            </b-table>
            
            <!-- <div class="justify-content-center row my-1">
              <b-pagination size="md" :total-rows="this.lista.length" :per-page="perPage" v-model="currentPage" />
            </div> -->
            <h1>{{user}}</h1>
        </b-col>
      </b-row>
    </div>
    <div>
      <!--  -----------------------------------------------------------------------------------
                                              MODAL CANCELAMENTO 
                ----------------------------------------------------------------------------------- -->
      <b-modal ref="modal-cancelamento" 
          id="modal-cancelamento" 
          hide-header
          body-class="p-0"
          centered 
          size="lg"
          @shown="focusModalCancelamento()" 
          headerClass= "p-2 border-bottom-0" 
          title="CANCELAR VENDA" >
        <b-overlay :show="cancelamento.parametros.overlayBaixando" 
                    no-wrap 
                    fixed 
                    z-index="1100" 
                    spinner-variant="primary"
                    spinner-type="border">
          <template #overlay>
            <div class="text-center">
              <b-icon icon="stopwatch" font-scale="3" animation="cylon"></b-icon>
              <p>Por favor. Aguarde!!!...</p>
            </div>
          </template>
        </b-overlay>
        <b-card bg-variant="light">
            <div slot="header">
                <i class='fa fa-align-justify'></i><strong>  Excluir/Cancelar Embarque</strong>
            </div>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Embarque:</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{cancelamento.dados.id}}</strong>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" md="3">
                <label>Motorista:</label>
              </b-col>
              <b-col cols="12" md="8">
                <strong>{{cancelamento.dados.nomeMotorista}}</strong>
              </b-col>
            </b-row>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Responsavel:</label>
              </b-col>
              <b-col cols="12" md="8">
                <strong>{{cancelamento.dados.nomeResponsavel}}</strong>
              </b-col>
            </b-row>
            
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                <label>Placa</label>
              </b-col>
              <b-col cols="12" md="3">
                <strong>{{cancelamento.dados.placa}}</strong>
              </b-col>
            </b-row>
            <hr>
            <b-row class="mb-1">
              <b-col cols="12" md="3">
                  <label for="motivoCancelamento">Motivo do Cancelamento</label>
              </b-col>
              <b-col cols="12" md="8">
                  <b-form-input type="text" ref="motivoCancelamento" id="motivoCancelamento" v-model="cancelamento.dados.motivo" 
                                :state="valMotivoCancelamento"
                                placeholder="Preencher o Motivo do Cancelamento" ></b-form-input>
              </b-col>
            </b-row>
        </b-card>

        <template #modal-footer="{ cancel }">
          <b-button v-if="valMotivoCancelamento" variant="success" @click="cancelar()">
            CONFIRMAR CANCELAMENTO
          </b-button>
          <b-button    variant="danger" @click="cancel()">
            Fechar
          </b-button>
        </template>
      </b-modal>
    </div>

    <!-- MODAL OCORRÊNCIAS -->
    <b-modal ref="modal-ocorrencias-embarque"
             id="modal-ocorrencias-embarque"
             hide-header
             body-class="p-0 overflow-hidden"
             centered
             size="lg">
      <div style="background: linear-gradient(135deg, #0069d9 0%, #0040a0 100%); padding: 1.1rem 1.4rem;">
        <div class="d-flex align-items-center">
          <i class="fa fa-file-text-o text-white mr-2" style="font-size:1.4rem;"></i>
          <div>
            <div class="text-white font-weight-bold" style="font-size:1.05rem;">Ocorrências de Entrega</div>
            <div class="text-white-50" style="font-size:0.82rem;">
              Pedido {{ entregaEmbarque.nVenda }} — {{ entregaEmbarque.nomeCliente }}
            </div>
          </div>
        </div>
      </div>
      <div class="p-3">
        <div v-if="entregaEmbarque.ocorrencias.carregando" class="text-center py-4">
          <b-spinner variant="primary" />
        </div>
        <div v-else-if="!entregaEmbarque.ocorrencias.itens.length" class="text-center py-4 text-muted">
          <i class="fa fa-inbox fa-2x mb-2"></i>
          <div>Nenhuma ocorrência registrada.</div>
        </div>
        <b-list-group v-else flush>
          <b-list-group-item v-for="oc in entregaEmbarque.ocorrencias.itens" :key="oc.ID" class="d-flex justify-content-between align-items-start px-2 py-2">
            <div>
              <div class="font-weight-bold">{{ oc.TIPO_DESCRICAO || oc.TIPO }}</div>
              <small class="text-muted">{{ oc.DESCRICAO }}</small><br>
              <small class="text-muted">{{ oc.DATA_OCORRENCIA }}</small>
            </div>
            <b-button size="sm" variant="outline-danger" @click="excluirOcorrenciaEmbarque(oc.ID)">
              <i class="fa fa-trash"></i>
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>

    <!-- MODAL DOCUMENTOS (CANHOTOS) -->
    <b-modal ref="modal-documentos-embarque"
             id="modal-documentos-embarque"
             hide-header
             body-class="p-0 overflow-hidden"
             centered
             size="lg">
      <div style="background: linear-gradient(135deg, #5a6268 0%, #343a40 100%); padding: 1.1rem 1.4rem;">
        <div class="d-flex align-items-center">
          <i class="fa fa-paperclip text-white mr-2" style="font-size:1.4rem;"></i>
          <div>
            <div class="text-white font-weight-bold" style="font-size:1.05rem;">Canhotos / Documentos</div>
            <div class="text-white-50" style="font-size:0.82rem;">
              Pedido {{ entregaEmbarque.nVenda }} — {{ entregaEmbarque.nomeCliente }}
            </div>
          </div>
        </div>
      </div>
      <div class="p-3">
        <div v-if="entregaEmbarque.documentos.carregando" class="text-center py-4">
          <b-spinner variant="secondary" />
        </div>
        <div v-else-if="!entregaEmbarque.documentos.itens.length" class="text-center py-4 text-muted">
          <i class="fa fa-inbox fa-2x mb-2"></i>
          <div>Nenhum documento registrado.</div>
        </div>
        <b-list-group v-else flush>
          <b-list-group-item v-for="doc in entregaEmbarque.documentos.itens" :key="doc.ID" class="d-flex justify-content-between align-items-start px-2 py-2">
            <div>
              <div class="font-weight-bold">{{ doc.TIPO_DESCRICAO || doc.TIPO }}</div>
              <small class="text-muted">{{ doc.DESCRICAO }}</small><br>
              <small class="text-muted">{{ doc.DATA_DOCUMENTO }}</small>
            </div>
            <b-button size="sm" variant="outline-danger" @click="excluirDocumentoEmbarque(doc.ID)">
              <i class="fa fa-trash"></i>
            </b-button>
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Fechar</b-button>
      </template>
    </b-modal>
    

  </div>
</template>

<script>
// https://github.com/simonbengtsson/jsPDF-AutoTable/blob/master/examples/webpack/main.js
import CecInputData from '@/components/Cec/CecInputData.vue'
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import ClientePesquisa from '../../pesquisa/ClientePesquisa.vue'
import moment from 'moment'
import { printHtmlReport, exportExcelXlsx , exportCsv } from '@/utils/RelatorioHTML';
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'


export default {
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tabelaPrincipal',
    preferVh: 74,
    useExternalPaging: true,
    filters: [
      { key: 'ID', type: 'number', label: 'Id' },
      { key: 'STATUS', type: 'string', label: 'Status' },
      { key: 'PLACA', type: 'string', label: 'Placa' },
      { key: 'NOME_MOTORISTA', type: 'string', label: 'Motorista' },
      { key: 'NOME_RESPONSAVEL', type: 'string', label: 'Responsável' },
      { key: 'PEDIDOS', type: 'number', label: 'Pedido' },
      { key: 'UNIDADES', type: 'number', label: 'Unidades' },
      { key: 'QUANT', type: 'number', label: 'Peso' },
      { key: 'DATA', type: 'date', label: 'Data' },
      { key: 'USUARIO_CADASTRO', type: 'string', label: 'Cadastro' }
    ]
  })],
  components: {
    CecInputData,
    SetFilter,
    ClientePesquisa,
    VueButtonSpinner,
  },
  data () {
    return {
      desabilitarSelectRow: false,
      filtro: {
        avancado: false
      },
      cancelamento: {
        parametros: {
          overlayBaixando: false,
          permissao: false,
          processando: false,
          busy: false
        },
        dados: {
          id: null,
          nomeResponsavel: '',
          sequencia: '',
          nomeMotorista: '',
          veiculo: '',
          placa: '',
          motivo: '',
        }
      },
      dadosModalInfo: {
        id: null,
        documento: null,
        dataVenda : null,
        nomeCliente: null,
        nomeVendedor: null,
        usuarioAlteracao: null,
        dataAlteracao: null,
        motivoAlteracao: null,
        usuarioCancelamento: null,
        dataCancelamento: null,
        motivoCancelamento: null,
        total: 0.00

      },
      tabelaPedidosEmbarcados: {
        isLoading : false,
        isBusy: false,
        currentPage: 1,
        perPage: 100,
        fields: [
          {
            key: "NENTREGA",
            class:'text-right',
            label: 'Entrega'
          },
          {
            key: "N_VENDA",
            class:'text-right',
            label: 'Pedido'
          },
          {
            key: "NOME_CLIENTE",
            class:'text-left',
            label: 'Cliente'
          },
          {
            key: "NOME_VENDEDOR",
            class:'text-left',
            label: 'Vendedor'
          },
          {
            key: "OP_PEDIDO",
            class:'text-left',
            label: 'Tipo'
          },
          {
            key: "ABATE_ID",
            class:'text-right',
            label: 'Lote'
          },
          {
            key: "OP_RETORNO_ENTREGA",
            class:'text-center',
            label: 'Entrega'
          },
          {
            key: "actions",
            class: "text-center align-middle p-0",
            thClass: "text-center align-middle p-0",
            label: 'Ações'
          }
        ],
        items: []
      },
      optionsSituacao: [
        { value: '', text: 'Todos' },
        { value: '0', text: 'Cancelado' },
        { value: '1', text: 'Fechado' },
        { value: '2', text: 'Aberto' },
        { value: '5', text: 'Entregue' }
      ],
      entregaEmbarque: {
        embarqueId: null,
        vendaId: null,
        nVenda: null,
        nomeCliente: '',
        ocorrencias: {
          carregando: false,
          itens: []
        },
        documentos: {
          carregando: false,
          itens: []
        }
      },
      status: '',
      isBusy: false,
      fields: [
        {
          key: "ID",
          label: 'Id',
          sortable: true
        },
        {
          key: "STATUS",
          label: 'Status', 
          sortable: true 
        },
        {
          key: "PLACA",
          label: 'Placa',
          sortable: true 
        },
        {
          key: "NOME_MOTORISTA",
          label: 'Motorista',
          sortable: true 
        },
        {
          key: "NOME_RESPONSAVEL",
          label: 'Resposável',
          sortable: true 
        },
        {
          key: "PEDIDOS",
          label: 'Pedido',
          class:'text-right', 
          sortable: true 
        },
        {
          key: "UNIDADES",
          label: 'Unidades',
          class:'text-right', 
          sortable: true 
        },
        {
          key: 'QUANT', 
          class:'text-right', 
          label: 'Peso', 
          sortable: true,
          formatter: (value, key, item) => 
            value ? value.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) : null
        },
        {
          key: "DATA",
          label: 'Data', 
          sortable: true,
          formatter: (value, key, item) => 
            moment(String(value)).format('DD/MM/YYYY')
        },
        {
          key: "USUARIO_CADASTRO",
          label: 'Cadastro', 
          sortable: true 
        },
        {
          key: "actions" ,
          label: 'Ações',
           thClass: "text-center align-middle p-0", // cabeçalho centralizado
            class: "text-center align-middle p-0"    // conteúdo centralizado na vertical e horizontal
        }
      ],
      currentPage: 1,
      perPage: 50,
      sortBy: null,
      sortDesc: false,
      filter: null,
      // registroSelecionadoId: null, // Removido para usar store
      modalDetails: { index: '', data: '' },
      columns: [
        {title: 'ID', dataKey: 'id'},
        {title: 'Name', dataKey: 'name'},
        {title: 'Country', dataKey: 'country'}
      ],
      rows: [
        {'id': 1, 'name': 'Shaw', 'country': 'Tanzania'},
        {'id': 2, 'name': 'Nelson', 'country': 'Kazakhstan'},
        {'id': 3, 'name': 'Garcia', 'country': 'Madagascar'}
      ]
    }
  },
  computed: {
    isDark () {
      return this.$store.getters['tema/IS_DARK']
    },
    valMotivoCancelamento() {
      return ((this.cancelamento.dados.motivo ) && (this.cancelamento.dados.motivo != '')) ? true : false 
    }
    ,
    user () {
      return '' // this.$store.state.dadosSessao.nome
    },
    dt1: {
      get () {
        return this.$store.getters['ordemExpedicao/DT1']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_DT1", value);
      }
    },
    dt2: {
      get () {
        return this.$store.getters['ordemExpedicao/DT2']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_DT2", value);
      }
    },
    id: {
      get () {
        return this.$store.getters['ordemExpedicao/ID']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_ID", value);
      }
    },
    pedido: {
      get () {
        return this.$store.getters['ordemExpedicao/PEDIDO']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_PEDIDO", value);
      }
    },
    clienteId: {
      get () {
        return this.$store.getters['ordemExpedicao/CLIENTE_ID']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_CLIENTE_ID", value)
      }
    },
    tipoSituacao: {
      get () {
        return this.$store.getters['ordemExpedicao/TIPO_SITUACAO']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_TIPO_SITUACAO", value)
      }
    },
    lista: {
      get () {
        return this.$store.getters['ordemExpedicao/LISTA']
      }, 
      set (value) {
        this.$store.commit("ordemExpedicao/SET_LISTA", value)
      }
    }
  },
  methods: {
    exportarHtml(){
      printHtmlReport({
        rows: this.lista,
        columns: this.fields,
        reportTitle: 'Listagem de Ordem de Expedição'
      });
    },
    exportarExcel(){
      exportExcelXlsx({
        rows: this.lista,
        columns: this.fields,
        filename: 'OrdemExpedicao.xlsx'
      });
    },
    exportarCsv(){
      exportCsv({
        rows: this.lista,
        columns: this.fields,
        filename: 'OrdemExpedicao.csv'
      });
    },
    somarQuantidadePedidos() {
      let auxQuant = 0
      for (let i = 0; i < this.itensFiltrados.length; i++) {
          auxQuant += this.itensFiltrados[i].PEDIDOS
      }
      return auxQuant.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0}) 
    },
    somarTotalPeso() {
      let auxQuant = 0.00
      for (let i = 0; i < this.itensFiltrados.length; i++) {
          auxQuant += this.itensFiltrados[i].QUANT
      }
      return auxQuant.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2}) 
    },
    exibirDetalhesTabela(row) {
      if(row._showDetails){
        this.$set(row, '_showDetails', false)
      }else{
        this.itensFiltrados.forEach(item => {
          this.$set(item, '_showDetails', false)
        })

        this.$nextTick(async () => {
          await this.atualizarListaPedidosEmbarcados(row)
          this.$set(row, '_showDetails', true)
        })
      }
    },
    async fecharDetalhesTabela() {
      for (let i = 0; i < this.itensFiltrados.length; i++) {
          this.$set(this.itensFiltrados[i], '_showDetails', false)
      }
    },
    async atualizarListaPedidosEmbarcados (row) {
      return new Promise((resolve, reject) => {
        this.tabelaPedidosEmbarcados.isBusy = true
        this.$http.get(`/api/protected/ordemexpedicao/getPedidosEmbarcados/${row.ID}`)
        .then(result =>{
          this.tabelaPedidosEmbarcados.items = result.data
          this.tabelaPedidosEmbarcados.isBusy = false
          resolve(true)
          return
        })
        .catch(erro => {
          this.tabelaPedidosEmbarcados.isBusy = false
          

          if (erro.response && erro.response.status && erro.response.status === 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          } else {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha ao atualizar lista de Pedidos ${erro}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          reject(false)
        })
      })
    },
    selecionarLinha(item) {
      this.$store.commit("ordemExpedicao/SET_REGISTRO_SELECIONADO_ID", item.ID)
    },
    rowClassSelecionado(item, type) {
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['ordemExpedicao/REGISTRO_SELECIONADO_ID']
      if (item.PEDIDOS > 0 && item.PEDIDOS_ENTREGUES >= item.PEDIDOS) return 'tr-embarque-entregue'
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    rowClassPedidoEntregue(item, type) {
      if (type !== 'row' || !item) return ''
      return item.OP_RETORNO_ENTREGA === '1' ? 'tr-pedido-entregue' : ''
    },
    traduzirTipoPedido (tipo) {
      if (!tipo) return 'INDEFINIDO'
      
      switch (tipo) {
        case  '1' : return 'VENDA'
        case  '2' : return 'SERVIÇO' 
        default: 'INDEFINIDO'
          break;
      }

    },
    colorirTipoPedido (tipo) {
      if (!tipo) return 'secondary'
      
      switch (tipo) {
        case  '1' : return 'primary'
        case  '2' : return 'info' 
        default: 'secondary'
          break;
      }

    },
    cancelar() {
      if (!this.valMotivoCancelamento) {
        this.toastCount++
        this.$root.$bvToast.toast('Informe o motivo!', {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'warning',
          appendToast: true
        })
        return
      }
      this.$store.commit('controle/setAguardando', true)
      let pacote = {
            id: this.cancelamento.dados.id,
            usuario : window.localStorage.getItem('login'),
            motivo: this.cancelamento.dados.motivo
          }

      return this.$http.post(`/api/protected/ordemexpedicao/delete`, pacote )
      .then(result => {
        if (result.data) {
          this.$store.dispatch('ordemExpedicao/GERAR_LISTA')
          this.$store.commit('controle/setAguardando', false)
          this.$refs['modal-cancelamento'].hide()

          this.toastCount++
          this.$root.$bvToast.toast('Ordem de Expedição Cancelada com Sucesso!', {
            title: 'Sucesso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          return 
        } else {
          this.toastCount++
          this.$root.$bvToast.toast('Não foi possivel Cancelar a Ordem de Expedição!', {
            title: 'Sucesso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })  
          this.$refs['modal-cancelamento'].hide()
          return 
        }
        
      })
      .catch(err => {
        this.$store.commit('controle/setAguardando', false)
        this.$refs['modal-cancelamento'].hide()
        this.toastCount++

        let msg 
        if (err.response && err.response.status) {
          msg = err.response.data
          this.$root.$bvToast.toast(msg, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.$root.$bvToast.toast(`Não foi possivel atender a solicitação. \nTente novamente !! ${err}`, {
            title: 'Falha',
            autoHideDelay: 5000,
            variant: 'danger',
            appendToast: true
          })
        }
      })

      
    },
    abrirModalCancelamento(item) {
      this.cancelamento.dados.id = item.ID
      this.cancelamento.dados.nomeResponsavel = item.NOME_RESPONSAVEL
      this.cancelamento.dados.nomeMotorista = item.NOME_MOTORISTA
      this.cancelamento.dados.placa = item.PLACA

      this.cancelamento.dados.motivo = ''

      //venda Aberta
      this.$refs['modal-cancelamento'].show()
      
    },
    focusModalCancelamento() {
      this.$refs.motivoCancelamento.focus()
    },
    limpar() {
      this.$store.commit("ordemExpedicao/SET_LIMPAR", null)
    },
    colorirStatus(valor) {
      if (valor == '0') return 'danger'
      else if (valor == '1') return 'warning'
      else if (valor == '2') return 'info'
      else if (valor == '3') return 'primary'
      else if (valor == '4') return 'success'
      else if (valor == '5') return 'success'
      else 'secondary'
    },
    traduzirSituacao(valor) {
      if (valor === '0') return 'CANCELADO'
      else if (valor === '1') return 'EM CADASTRO'
      else if (valor === '2') return 'AGUARDANDO'
      else if (valor === '3') return 'EMBARCANDO'
      else if (valor === '4') return 'FINALIZADO'
      else if (valor === '5') return 'ENTREGUE'
      else ''
    },
    details (item) {
      alert(JSON.stringify(item.item.ID))
    },
    async edit (items) {
      if (this.desabilitarSelectRow == true) {
        return
      }
      
      // @row-dblclicked passa array de items
      const item = Array.isArray(items) ? items[0] : items
      
      this.$store.commit("ordemExpedicao/SET_REGISTRO_SELECIONADO_ID", item.ID)
      await this.fecharDetalhesTabela()

      this.$store.commit('controle/setAguardando', true)
      this.$router.push(`/expedicao/ordemexpedicao/edit/${item.ID}`)
    },
    async novo () {
     this.$store.commit("ordemExpedicao/SET_REGISTRO_SELECIONADO_ID", null)
     await this.fecharDetalhesTabela()
     this.$router.push(`/expedicao/ordemexpedicao/add`)
    },
    pesquisar (ctx) {
      this.$store.commit('controle/setAguardando', true)
      // NÃO limpar REGISTRO_SELECIONADO_ID aqui para manter a linha pintada ao retornar
      this.$store
      .dispatch('ordemExpedicao/GERAR_LISTA')
      .then((data) => {

        this.$store.commit('controle/setAguardando', false)
        this.status = true // or success
        return
      }).catch((error) => {
        if (error) {
          this.status = false // or error
        }
      })
    },
    async confirmarEntregaEmbarque(item) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Confirmar que o embarque #${item.ID} foi totalmente entregue? O status passará para ENTREGUE.`,
        { title: 'Confirmar Entrega Total', okVariant: 'success', okTitle: 'Confirmar', cancelTitle: 'Cancelar', centered: true }
      )
      if (!ok) return
      try {
        await this.$http.post('/api/protected/ordemexpedicao/marcarEmbarqueEntregue', {
          embarqueId: item.ID,
          usuario: window.localStorage.getItem('login')
        })
        this.$root.$bvToast.toast(`Embarque #${item.ID} marcado como ENTREGUE!`, {
          title: 'Sucesso', autoHideDelay: 3000, variant: 'success', appendToast: true
        })
        this.$store.dispatch('ordemExpedicao/GERAR_LISTA')
      } catch (err) {
        const msg = err.response && err.response.data ? err.response.data : String(err)
        this.$root.$bvToast.toast(`Falha: ${msg}`, { title: 'Falha', autoHideDelay: 4000, variant: 'warning', appendToast: true })
      }
    },
    async confirmarEntregaPedidoEmbarque(pedido, embarqueId) {
      const ok = await this.$bvModal.msgBoxConfirm(
        `Confirmar entrega do pedido #${pedido.N_VENDA} — ${pedido.NOME_CLIENTE}?`,
        { title: 'Confirmar Entrega', okVariant: 'success', okTitle: 'Confirmar', cancelTitle: 'Cancelar', centered: true }
      )
      if (!ok) return
      try {
        await this.$http.post('/api/protected/motorista/marcarEntregue', {
          vendaId: pedido.SEQUENCIA,
          embarqueId: embarqueId,
          usuario: window.localStorage.getItem('login')
        })
        this.$root.$bvToast.toast(`Pedido #${pedido.N_VENDA} marcado como entregue!`, {
          title: 'Sucesso', autoHideDelay: 3000, variant: 'success', appendToast: true
        })
        // Atualiza sub-tabela e lista principal
        const itemPrincipal = this.itensFiltrados.find(i => i.ID === embarqueId)
        if (itemPrincipal) await this.atualizarListaPedidosEmbarcados(itemPrincipal)
        this.$store.dispatch('ordemExpedicao/GERAR_LISTA')
      } catch (err) {
        const msg = err.response && err.response.data ? err.response.data : String(err)
        this.$root.$bvToast.toast(`Falha: ${msg}`, { title: 'Falha', autoHideDelay: 4000, variant: 'warning', appendToast: true })
      }
    },
    async abrirOcorrenciasEmbarque(pedido) {
      this.entregaEmbarque.vendaId = pedido.SEQUENCIA
      this.entregaEmbarque.nVenda = pedido.N_VENDA
      this.entregaEmbarque.nomeCliente = pedido.NOME_CLIENTE
      this.entregaEmbarque.ocorrencias.itens = []
      this.$refs['modal-ocorrencias-embarque'].show()
      this.entregaEmbarque.ocorrencias.carregando = true
      try {
        const res = await this.$http.get(`/api/protected/motorista/ocorrencias/${pedido.SEQUENCIA}`)
        this.entregaEmbarque.ocorrencias.itens = res.data || []
      } catch (err) {
        this.$root.$bvToast.toast('Falha ao carregar ocorrências.', { title: 'Falha', variant: 'warning', appendToast: true })
      } finally {
        this.entregaEmbarque.ocorrencias.carregando = false
      }
    },
    async excluirOcorrenciaEmbarque(id) {
      const ok = await this.$bvModal.msgBoxConfirm('Remover esta ocorrência?', { title: 'Confirmar', okVariant: 'danger', okTitle: 'Remover', cancelTitle: 'Cancelar', centered: true })
      if (!ok) return
      try {
        await this.$http.delete(`/api/protected/motorista/ocorrencia/${id}`)
        this.entregaEmbarque.ocorrencias.itens = this.entregaEmbarque.ocorrencias.itens.filter(o => o.ID !== id)
        this.$root.$bvToast.toast('Ocorrência removida.', { title: 'Sucesso', variant: 'success', appendToast: true })
      } catch (err) {
        this.$root.$bvToast.toast('Falha ao remover ocorrência.', { title: 'Falha', variant: 'warning', appendToast: true })
      }
    },
    async abrirDocumentosEmbarque(pedido) {
      this.entregaEmbarque.vendaId = pedido.SEQUENCIA
      this.entregaEmbarque.nVenda = pedido.N_VENDA
      this.entregaEmbarque.nomeCliente = pedido.NOME_CLIENTE
      this.entregaEmbarque.documentos.itens = []
      this.$refs['modal-documentos-embarque'].show()
      this.entregaEmbarque.documentos.carregando = true
      try {
        const res = await this.$http.get(`/api/protected/motorista/documentos/${pedido.SEQUENCIA}`)
        this.entregaEmbarque.documentos.itens = res.data || []
      } catch (err) {
        this.$root.$bvToast.toast('Falha ao carregar documentos.', { title: 'Falha', variant: 'warning', appendToast: true })
      } finally {
        this.entregaEmbarque.documentos.carregando = false
      }
    },
    async excluirDocumentoEmbarque(id) {
      const ok = await this.$bvModal.msgBoxConfirm('Remover este documento?', { title: 'Confirmar', okVariant: 'danger', okTitle: 'Remover', cancelTitle: 'Cancelar', centered: true })
      if (!ok) return
      try {
        await this.$http.delete(`/api/protected/motorista/documento/${id}`)
        this.entregaEmbarque.documentos.itens = this.entregaEmbarque.documentos.itens.filter(d => d.ID !== id)
        this.$root.$bvToast.toast('Documento removido.', { title: 'Sucesso', variant: 'success', appendToast: true })
      } catch (err) {
        this.$root.$bvToast.toast('Falha ao remover documento.', { title: 'Falha', variant: 'warning', appendToast: true })
      }
    },
    imprimir (id) {      this.$store.commit('controle/setAguardando', true)
      let uri = '/api/protected/relatorios/relvenda?id=' + id
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.$store.commit('controle/setAguardando', false)
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'relVenda.pdf') 
          link.download = 'relVenda.pdf'
          // document.body.appendChild(link)
          //link.click()
          // document.body.removeChild(link)
          const janela = window.open(link)
          /*
          setTimeout(() =>
            { 
                janela.document.title = 'Relatório de Vendas'; 
            }, 1000);
            */
          
          janela.onload = function(){
            setTimeout(() => {
              janela.document.title = id +' Relatório de Vendas'
            }, 2000);
          }

          this.$root.$bvToast.toast(`Relatório Gerado com sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'success',
            appendToast: true
          })
          
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
        })
    }
  },
  created () {
  },
  async mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
.cec-row-selected {
  background-color: #c2cfd6 !important;
  color: #000000 !important;
}

.tr-embarque-entregue {
  background-color: #d4edda !important;
}

.tr-embarque-entregue > td {
  background-color: #d4edda !important;
}

.tr-pedido-entregue {
  background-color: #d4edda !important;
}

.tr-pedido-entregue > td {
  background-color: #d4edda !important;
}

table tbody tr {
  padding: 0.22rem;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.205);
  background-color: transparent !important;
}

table tbody tr td {
  padding: 0.22rem;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.205);
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/views/expedicao/ordemexpedicao/OrdemExpedicaoListagem.vue